const verifyImport = async (columns, rows) => {
  return $.ajax({
    url: `/api/v1/resident_import/verify_import`,
    method: "POST",
    data: {
      columns,
      rows,
    },
    success: (data) => {
      return data;
    },
  });
};

export default verifyImport;
